"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTarget = exports.getPlacementParts = void 0;

var _react = require("react");

var _types = require("./types");

var _isRef = _interopRequireDefault(require("../../utils/isRef"));

var _canUseDOM = _interopRequireDefault(require("../../utils/canUseDOM"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var getPlacementParts = function getPlacementParts() {
  var placement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'bottom';
  return placement.split('-');
};

exports.getPlacementParts = getPlacementParts;

var getTargetType = function getTargetType(target) {
  if (!target) {
    return _types.TargetType.None;
  }

  if ((0, _isRef.default)(target)) {
    return _types.TargetType.Reference;
  }

  if (typeof target === 'function') {
    return _types.TargetType.RenderProp;
  }

  return _types.TargetType.Element;
};

var getDomNode = function getDomNode(from) {
  return from && 'current' in from ? from.current : null;
};

var manageEventsOf = function manageEventsOf(node, events, actions, operation) {
  /* istanbul ignore next */
  if (!_canUseDOM.default) {
    return;
  }

  Object.entries(events).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        eventType = _ref2[0],
        action = _ref2[1];

    var fn = operation === 'add' ? 'addEventListener' : 'removeEventListener';
    var handler = actions[action];
    node[fn](eventType, handler);
  });
};

var useTarget = function useTarget(props) {
  var target = props.target,
      visible = props.visible,
      internalNodeRef = props.internalNodeRef,
      actions = props.actions,
      manageEvents = props.manageEvents;

  var _useState = (0, _react.useState)(getDomNode(target)),
      _useState2 = _slicedToArray(_useState, 2),
      node = _useState2[0],
      setNode = _useState2[1];

  var _useState3 = (0, _react.useState)(getTargetType(target)),
      _useState4 = _slicedToArray(_useState3, 2),
      type = _useState4[0],
      setType = _useState4[1];

  (0, _react.useEffect)(function () {
    var newNode = internalNodeRef.current || getDomNode(target);
    var newType = getTargetType(target);
    var eventsType = manageEvents;

    if (eventsType === undefined) {
      eventsType = visible === undefined && newType !== _types.TargetType.RenderProp ? 'click' : undefined;
    }

    setNode(newNode);
    setType(newType);

    if (newNode && eventsType) {
      manageEventsOf(newNode, _constants.eventsForTrigger[eventsType], actions, 'add');
    }

    return function () {
      if (node && eventsType) {
        manageEventsOf(node, _constants.eventsForTrigger[eventsType], actions, 'remove');
      }
    };
  }, [actions, internalNodeRef, manageEvents, node, setNode, target, visible]);
  return [node, type];
};

exports.useTarget = useTarget;